export const arrayStatusBlog = [
  {
    id: 10,
    name: 'borrador',
    labelMain: 'Borrador',
    classColorTxt: 'gray',
  },
  {
    id: 11,
    name: 'activo',
    labelMain: 'Activo',
    classColorTxt: 'green',
  },
  {
    id: 12,
    name: 'inactivo',
    labelMain: 'Inactivo',
    classColorTxt: 'darkRed',
  },
]

//Convierte el array de estatus en un objeto
export const fnObjNameStatusBlog = () => {
  const obj = {}
  arrayStatusBlog.forEach((item) => (obj[item.name] = item.id))
  return obj
}

//Devuelve el estatus objeto por ID
export const findArrayStatusBlog = (id) => {
  const findArray = arrayStatusBlog.find((item) => item.id === parseInt(id))
  return findArray
}

//Devuelve un arreglo para select/options de estatus blogPost
export const fnArraySelectStatusBlog = () => {
  const resp = arrayStatusBlog.map((item) => ({
    value: item.id,
    label: item.labelMain,
  }))
  return resp
}

//////////////////////////

export const arrayLayoutBlog = [
  { value: 'card', label: 'card' },
  { value: 'card-image', label: 'card-image' },
]

export const arrayCategoryBlog = [
  { value: 'comunicacion', label: 'Comunicación' },
  { value: 'atencion_ciudadana', label: 'Atención ciudadana' },
  { value: 'general', label: 'General' },
]

//Devuelve la categoria objeto por ID
export const findCategoryBlog = (value) => {
  const findArray = arrayCategoryBlog.find((item) => item.value === value)
  return findArray
}
